import { MouseEvent, useEffect, useMemo, useState } from 'react';
import styled, { css } from 'styled-components';

import useMedia from '~hooks/useMedia';

import { getOptionText } from './helper';
import Option from './Option';
import OptionsContainer from './OptionsContainer';
import SelectMobile from './SelectMobile';
import * as S from './style';

export type OptionsContainerAlign = 'left' | 'center' | 'right';
export interface TinyDropDownOption {
  label?: string;
  value: string;
  selected?: boolean;
  disabled?: boolean;
}
export interface Props {
  value?: string;
  options: TinyDropDownOption[];
  $width?: string;
  align?: OptionsContainerAlign;
  onChange?: (value: string) => void;
}

export default function TinyDropDown({
  value,
  $width,
  options,
  align = 'center',
  onChange,
}: Props) {
  const { isMobile } = useMedia();
  const [open, setOpen] = useState<boolean>(false);
  const [selectedText, setSelectedText] = useState<string>();
  const displayText = useMemo(() => {
    if (!options || options?.length === 0) {
      return <S.NoData>정보없음</S.NoData>;
    }

    if (selectedText) {
      return <S.SelectedText>{selectedText}</S.SelectedText>;
    }

    return <S.Placeholder>Choose here</S.Placeholder>;
  }, [selectedText, options]);

  const handleClickDropDown = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    const selectedOption = options.find((option) => option.value === value);

    setSelectedText(getOptionText(selectedOption));
  }, [value, options]);

  return (
    <S.Wrapper $width={$width}>
      {displayText}
      {options && options.length > 0 && (
        <>
          {isMobile ? (
            <SelectMobile value={value} onChange={onChange} options={options} />
          ) : (
            <>
              <S.ButtonDropDown title={selectedText} onClick={handleClickDropDown} />
              <OptionsContainer open={open} setOpen={setOpen} align={align}>
                {options.map((option) => (
                  <Option
                    key={option.value}
                    label={getOptionText(option)}
                    value={option.value}
                    disabled={option.disabled}
                    selected={option.value === value}
                    onClick={onChange}
                  />
                ))}
              </OptionsContainer>
            </>
          )}
        </>
      )}
    </S.Wrapper>
  );
}
